import React from 'react';
import { Emoji } from 'emoji-mart';

import { getCurrentUserId } from '../services/store-service';

import UserName from './user-name';
import Tooltip from './tooltip';

const ReactionItem = ({ reaction, users, onReactionSelect, onReactionRemove }) => {
    const handleClick = () => {
        onReactionSelect && onReactionSelect({ colons: reaction });
    }

    return (
        <Tooltip tooltip={<ReactionCopy users={users} reaction={reaction} />}>
            <span className="reaction-item" onClick={users.includes(getCurrentUserId()) ? onReactionRemove : handleClick}>
                <Emoji emoji={reaction} size={16} />

                <span className="count">
                    {users.length}
                </span>
            </span>
        </Tooltip>
    )
}

const ReactionCopy = ({ users, reaction }) => {
    const currentUserId = getCurrentUserId();
    const currentUserReacted = users.includes(currentUserId);

    return (
        <div className="message-reaction-copy">
            <strong>
                {
                    currentUserReacted ? 'You (click to remove)' : ''
                }

                {
                    users.map((userId, index) => userId !== currentUserId && (
                        <React.Fragment key={index}>
                            {
                                index !== 0 || currentUserReacted ? ', ' : ''
                            }

                            <UserName id={userId} />
                        </React.Fragment>
                    ))
                }
            </strong>

            &nbsp;reacted with {reaction}
        </div>
    )
}

const MessageReactions = ({ reactions, onReactionSelect, onReactionRemove }) => {
    reactions = reactions.reduce((reactions, reaction) => {
        if (!reactions[reaction.value]) {
            reactions[reaction.value] = [];
        }

        reactions[reaction.value].push(reaction.member_id);
        return reactions;
    }, {});

    return (
        <div className="message-reactions">
            {
                Object.keys(reactions).map(reaction => (
                    <ReactionItem key={reaction} users={reactions[reaction]} reaction={reaction} onReactionRemove={onReactionRemove} onReactionSelect={onReactionSelect} />
                ))
            }
        </div>
    );
}

export default MessageReactions;
